const routes = {
  root: "/",
  favorites: "/favorites",
  anyPath: "*",
};

export default routes;
